<div class="chartContainer">
    <canvas baseChart class="chart" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" [width]="width" [height]="height" type="line"></canvas>
</div>